import { Module } from "@7egend/dxp-web-core/lib/bootstrap"
import loadable from "@loadable/component"

export const reservationsSetup: Module = {
	routes: [
		// Reservations List
		{
			component: loadable(
				async () => (await import("./Reservations")).Reservations
			),
			path: "footlab/reservations",
			exact: true,
		},
		// Reservations Create
		{
			component: loadable(
				async () => (await import("./ReservationsEditor")).ReservationsEditor
			),
			path: "/footlab/reservations/add",
		},
		// Reservations Update
		{
			component: loadable(
				async () => (await import("./ReservationsEditor")).ReservationsEditor
			),
			path: "/footlab/reservations/edit/:id",
		},
	],
	menus: [
		{
			title: {
				key: "footlab.reservations.menu.title",
				en: "Reservations",
				es: "Reservas",
				pt: "Reservas",
			},
			path: "footlab/reservations",
			permission: "footlab.reservations.list",
			children: [
				{
					title: {
						key: "footlab.reservations.edit.menu.title",
						en: "Edit reservation",
						es: "Editar reserva",
						pt: "Editar reserva",
					},
					path: "footlab/reservations/edit",
					visible: false,
					permission: "footlab.reservations.edit",
				},
			],
		},
	],
}
